module.exports = __webpack_public_path__ + "img/Shanghai.26754985.png";